import { render } from "./mobile.vue?vue&type=template&id=51606eb9&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=51606eb9&scoped=true&lang=css"

import exportComponent from "/Users/zqj/Documents/git/H5/Website/WaterHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51606eb9"]])

export default __exports__